import {Box, Typography, CircularProgress} from '@mui/material'

export default function MainFooter() {
  return (
    <Box display="flex" alignItems="center" sx={{mt:1, ml:2}}>
      <CircularProgress size="18px" sx={{color:"gray"}}/>
      <Typography variant="subtitle1" sx={{ml:1.5, fontWeight:"bold", color:"gray"}}>
        情報取得中です。
      </Typography>
    </Box>
  )
}